import React from 'react';
import SData from "../../helpers/SData";
import Tag from "../views/Tag";
import {ClockCircleOutlined} from "@ant-design/icons";
import SystemFunctions from "../../helpers/SystemFunctions";
import Card from "../views/Card";
import PropTypes from "prop-types";
import "./TaskItem.less";
import {Checkbox, Empty, Popconfirm, Tooltip} from "antd";
import TimeLogic from "../../helpers/TimeLogic";

class CurrentTask extends React.Component {

    updateInterval = null;

    componentDidMount() {
        this.removeUpdater();
        this.updateInterval = setInterval(() => {
            if (SData.base != null && SData.base.purpose.status === 2 && SData.base.status === 1) {
                this.forceUpdate()
            }
        }, 1000);
    }

    componentWillUnmount() {
        this.removeUpdater();
    }

    removeUpdater = () => {
        if (this.updateInterval != null) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            fullDescTask: false,
            taskCheckbox: false,
        };
    }

    render() {
        let currentTask = SData.currentTask;
        if (currentTask == null) {
            return (<Card className='noTask-placeholder'>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Цель не содержит задач'/>
            </Card>);
        }
        const options = SData.base.global.tasksTags;
        let tags = [];
        for (let i = 0; i < currentTask.tags.length; i++) {
            let tag = currentTask.tags[i];
            if (options[tag] == null) {
                continue;
            }
            tags.push(<Tag color={options[tag].color}>{options[tag].label}</Tag>)
        }
        let completeState = true;
        if (SData.base.purpose == null || SData.base.purpose.status !== 2) {
            completeState = false;
        }
        let taskPartly = SData.base.data.dayNeed.taskPartly;
        let partlyTime = 0;
        let partlyPercent = 0;
        if (SData.base.purpose.status === 2 && SData.base.status !== 0 && taskPartly != null && taskPartly['id'] === currentTask['id']) {
            partlyTime = taskPartly['time'];
            partlyPercent = Math.round((partlyTime / (currentTask['time'] * 60)) * 100);
        }
        let dt = 0;
        if (SData.base.purpose.status === 2 && SData.base.status === 1) {
            dt = Math.floor(TimeLogic.getDate().getTime() / 1000) - SData.base.data.last_add_time;
            console.log(TimeLogic.getDate().getTime() / 1000, SData.base.data.last_add_time, dt);
        }
        let statusTag = <Tooltip className='deadline' placement="bottomLeft"
                                 title='Остаток времени на выполнение задачи'><Tag icon={<ClockCircleOutlined/>}
                                                                                   className='primary'>{SystemFunctions.secondsToTextTimeout(currentTask.time * 60 - currentTask.time_used - dt)}</Tag></Tooltip>;
        return (<div className={'TaskItem dashboard not-draggable'}>
            <Card>
                <div className='main'>
                    {partlyTime === 0 ? <div className='name'>
                        <Popconfirm arrowPointAtCenter={true}
                                    okType={completeState ? 'success' : 'secondary'}
                                    okButtonProps={{className: 'btn-object'}}
                                    cancelButtonProps={{className: 'btn-object', style: completeState ? {} : {display: 'none'}}}
                                    placement="bottomLeft"
                                    title={completeState ? "Вы действительно хотите отметить задачу выполненной?" : "В режиме редактирования нельзя завершать задачи"}
                                    onCancel={() => this.setState({taskCheckbox: false})}
                                    onVisibleChange={(v, e) => {
                                        if (!v) { // && e == null
                                            this.setState({taskCheckbox: false});
                                        }
                                    }}
                                    onConfirm={this.props.onCompleteTask} okText={completeState ? "Да" : "Ок"}
                                    cancelText="Отмена">
                            <Checkbox className='checkbox'
                                      checked={this.state.taskCheckbox}
                                      onChange={() => {
                                          if (SData.base.purpose == null || SData.base.purpose.status !== 2) {
                                              return;
                                          }
                                          this.setState({taskCheckbox: true});
                                      }}>{currentTask.name}</Checkbox>
                        </Popconfirm>
                    </div> : <div className='name'>
                        <span className='taskPercent'>{partlyPercent}%</span>
                        <span className='text'>{currentTask.name}</span>
                    </div>}
                    {currentTask.data.description == null || currentTask.data.description == '' ?
                        <div className='noDesc'/> :
                        <div
                            className={'desc ' + (this.state.fullDescTask ? 'fullDesc' : 'prevDesc')}
                            onClick={() => {
                                this.setState({fullDescTask: !this.state.fullDescTask});
                            }}>{currentTask.data.description}</div>}
                    <div className='bottomContainer'>
                        <div className='tags'>
                                <span className='time'>
                                    {statusTag}
                                </span>
                            {tags}
                        </div>
                    </div>
                </div>
                <div className='right'>
                    <div className='noDragPlaceholder'/>
                </div>
            </Card>
        </div>);
    }
}

CurrentTask.propTypes = {
    onCompleteTask: PropTypes.func,
};

export default CurrentTask;